"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFIX_CLS = void 0;
var react_1 = __importStar(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
exports.PREFIX_CLS = 'odc-accordion';
var events = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick', 'onScroll'];
var Accordion = function Accordion(props) {
  var children = props.children,
    _a = props.accordion,
    accordion = _a === void 0 ? true : _a,
    _b = props.headerTitleSize,
    headerTitleSize = _b === void 0 ? 5 : _b,
    scrollIntoView = props.scrollIntoView,
    accordionProps = props.accordionProps,
    _c = props.bordered,
    bordered = _c === void 0 ? true : _c,
    _d = props.radius,
    radius = _d === void 0 ? '6' : _d;
  var _e = __read(react_1["default"].useState([]), 2),
    activeKey = _e[0],
    setActiveKey = _e[1];
  var getActiveKeysArray = function getActiveKeysArray(activeKey) {
    var currentActiveKeys = activeKey;
    if (!Array.isArray(currentActiveKeys)) {
      currentActiveKeys = [currentActiveKeys];
    }
    return currentActiveKeys.map(function (key) {
      return String(key);
    });
  };
  var childrenList = react_1.Children.toArray(children);
  var handleItemClick = function handleItemClick(panelKey) {
    if (accordion) {
      setActiveKey(activeKey[0] === String(panelKey) ? [] : [String(panelKey)]);
    } else {
      var currentActiveKeys = getActiveKeysArray(activeKey);
      var index = currentActiveKeys.indexOf(String(panelKey));
      if (index > -1) {
        currentActiveKeys.splice(index, 1);
      } else {
        currentActiveKeys.push(String(panelKey));
      }
      setActiveKey(currentActiveKeys);
    }
  };
  var getChild = function getChild(child, index) {
    if (!child) return null;
    var key = String(child.props.panelKey) || String(index);
    var isActive = false;
    if (accordion) {
      isActive = activeKey[0] === key;
    } else {
      isActive = activeKey.indexOf(key) > -1;
    }
    var childProps = __assign({
      key: key,
      panelKey: key,
      children: child.props.children,
      isActive: isActive,
      onItemClick: handleItemClick,
      headerTitleSize: headerTitleSize,
      scrollIntoView: scrollIntoView
    }, child.props);
    return react_1["default"].cloneElement(child, childProps);
  };
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, accordionProps, (0, spaui_utils_1.globalProps)(props, {
    className: "".concat(exports.PREFIX_CLS),
    events: events
  }, Accordion), {
    bordered: bordered,
    radius: radius
  }), childrenList.map(function (child, index) {
    return getChild(child, index);
  }));
};
exports["default"] = react_1["default"].memo(Accordion);